"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarsNomads = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const utils_1 = require("../../utils/utils");
const AresHandler_1 = require("../../ares/AresHandler");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const HellasBoard_1 = require("../../boards/HellasBoard");
const VastitasBorealisBoard_1 = require("../../boards/VastitasBorealisBoard");
const TileType_1 = require("../../TileType");
class MarsNomads extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARS_NOMADS,
            cost: 13,
            metadata: {
                cardNumber: 'X59',
                description: 'PLACE THE NOMADS on a non-reserved, empty area on the game board.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('MOVE THE NOMADS to an adjacent, non-reserved empty area and collect THE PLACEMENT BONUS as if placing a special tile there. No tiles may be placed on the Nomad area.', (eb) => {
                        eb.empty().startAction.nomads(1).asterix();
                    });
                    b.br;
                    b.nomads(1).asterix();
                }),
            },
        });
    }
    canPlay(player) {
        const spaces = player.game.board.getNonReservedLandSpaces();
        return spaces.length > 0;
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select space for Nomads', player.game.board.getNonReservedLandSpaces(), TileType_1.TileType.PERSEVERANCE_LANDING, (space) => {
            space.hasNomads = true;
            return undefined;
        });
    }
    canAct(player) {
        const board = player.game.board;
        if (board.spaces.some((space) => space.hasNomads) === false)
            return false;
        const eligibleAdjacentSpaces = this.getEligibleDestinationSpaces(player);
        return eligibleAdjacentSpaces.length > 0;
    }
    action(player) {
        const game = player.game;
        const board = game.board;
        const eligibleAdjacentSpaces = this.getEligibleDestinationSpaces(player);
        return new SelectSpace_1.SelectSpace('Select adjacent space to move Nomads to', eligibleAdjacentSpaces, TileType_1.TileType.PERSEVERANCE_LANDING, (space) => {
            board.spaces.forEach((s) => s.hasNomads = false);
            space.hasNomads = true;
            game.grantSpaceBonuses(player, space);
            game.grantOceanAdjacencyBonuses(player, space, true);
            HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, space);
            VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, space);
            AresHandler_1.AresHandler.ifAres(game, (aresData) => {
                AresHandler_1.AresHandler.earnAdjacencyBonuses(aresData, player, space);
            });
            TurmoilHandler_1.TurmoilHandler.resolveTilePlacementBonuses(player, space);
            return undefined;
        });
    }
    getEligibleDestinationSpaces(player) {
        const board = player.game.board;
        if (board.spaces.some((space) => space.hasNomads) === false)
            return [];
        const availableSpaces = board.getAvailableSpacesOnLand(player).filter((space) => space.player === undefined);
        const currentNomadSpace = board.spaces.find((space) => space.hasNomads);
        const adjacentSpaces = board.getAdjacentSpaces(currentNomadSpace);
        return utils_1.intersection(availableSpaces, adjacentSpaces);
    }
}
exports.MarsNomads = MarsNomads;
//# sourceMappingURL=MarsNomads.js.map